// Backend job status codes: JQ/JQA queued, JR/JRA running (active);
// JP pass, JF fail (terminal). A two-char prefix check covers the async
// variants (JQA/JRA) too. Mirrors isActiveJobStatus in useConversationActiveJobs.
export function getStatusCode(status: unknown): string {
  if (typeof status !== 'string') return '';
  return status.split('#')[0];
}

export function isActive(status: unknown): boolean {
  const code = getStatusCode(status);
  return code.startsWith('JQ') || code.startsWith('JR');
}

export function isRunning(status: unknown): boolean {
  return getStatusCode(status).startsWith('JR');
}

export function isPass(status: unknown): boolean {
  return getStatusCode(status) === 'JP';
}

export function isFail(status: unknown): boolean {
  return getStatusCode(status) === 'JF';
}

/**
 * Counts a conversation's jobs by ledger bucket. Used by TraceDrawer to drive
 * the Jobs-tab conditional rendering (renders if ≥1 job ever) and badges
 * (active count while live, total when idle). Counts only jobs the ledger
 * actually shows — active (JQ/JR prefixes) + completed (JP/JF) — so the tab
 * is never present-but-blank.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function countLedgerJobs(jobs: any[] | undefined | null): {
  active: number;
  completed: number;
  total: number;
} {
  if (!Array.isArray(jobs)) {
    return { active: 0, completed: 0, total: 0 };
  }
  let active = 0;
  let completed = 0;
  for (const job of jobs) {
    if (isActive(job?.status)) active += 1;
    else if (isPass(job?.status) || isFail(job?.status)) completed += 1;
  }
  return { active, completed, total: active + completed };
}
